export default __webpack_public_path__ + "static/media/P314.1.697f807d.mp3";